export enum SocialCodeEnum {
    VK = 'code',
    Google = 'token',
    Facebook = 'code',
    OK = 'code'
}



// WEBPACK FOOTER //
// ./src/app/shared/dictionaries/SocialCodeEnum.ts